import React, { useEffect, useState } from "react";
import { RSelect } from "../Component";
import { PinTypes } from "../../utils/Utils";


const PinTypeDropdown = ({ value, isMulti = false, onSelect, placeholder, ...props }) => {
  const [list, setList] = useState();

  useEffect(() => {
    setList(PinTypes);
    return () => {
      setList();
    };
  }, []);

  return (
    <RSelect
      options={list ?? []}
      isMulti={isMulti}
      placeholder={placeholder}
      value={value ?? null}
      onChange={(e) => {
        onSelect(e);
      }}
      {...props}
    />
  );
};

export default PinTypeDropdown;